var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPauseFill1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71429 5H6.28571C6.20994 5 6.13727 5.10536 6.08368 5.29289C6.0301 5.48043 6 5.73478 6 6V18C6 18.2652 6.0301 18.5196 6.08368 18.7071C6.13727 18.8946 6.20994 19 6.28571 19H9.71429C9.79006 19 9.86273 18.8946 9.91632 18.7071C9.9699 18.5196 10 18.2652 10 18V6C10 5.73478 9.9699 5.48043 9.91632 5.29289C9.86273 5.10536 9.79006 5 9.71429 5ZM17.7143 5H14.2857C14.2099 5 14.1373 5.10536 14.0837 5.29289C14.0301 5.48043 14 5.73478 14 6V18C14 18.2652 14.0301 18.5196 14.0837 18.7071C14.1373 18.8946 14.2099 19 14.2857 19H17.7143C17.7901 19 17.8627 18.8946 17.9163 18.7071C17.9699 18.5196 18 18.2652 18 18V6C18 5.73478 17.9699 5.48043 17.9163 5.29289C17.8627 5.10536 17.7901 5 17.7143 5Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseFill1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause-fill-1.13ca76892fbb00032a4a213a886841d8.svg";